import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
export var StyledContainer = styled(Box)(function (_ref) {
  var size = _ref.size;
  return {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiNativeSelect-icon': {
      width: size === 'small' ? '0.7em' : null,
      height: size === 'small' ? '0.7em' : null,
      right: size === 'small' ? '3px' : null,
      top: size === 'small' ? 'calc(50% - 9px)' : null
    }
  };
});
export var StyledSelect = styled('div')(function (_ref2) {
  var required = _ref2.required,
    size = _ref2.size,
    theme = _ref2.theme,
    value = _ref2.value;
  return {
    minWidth: size === 'small' ? 50 : 80,
    '& select': {
      padding: '0.8rem 2rem 0.7rem 1rem !important'
    },
    '& fieldset': {
      borderColor: required && !value ? theme.palette.secondary.main : null
    }
  };
});
export var StyledSpacer = styled('span')(function (_ref3) {
  var size = _ref3.size,
    theme = _ref3.theme;
  return {
    color: theme.palette.default.light,
    padding: size === 'small' ? '0 3px' : '0 5px',
    fontSize: size === 'small' ? '14px' : '18px',
    fontWeight: 700
  };
});